import { render, staticRenderFns } from "./PlatformCy.vue?vue&type=template&id=77f68cb2&scoped=true"
import script from "./PlatformCy.vue?vue&type=script&lang=js"
export * from "./PlatformCy.vue?vue&type=script&lang=js"
import style0 from "./PlatformCy.vue?vue&type=style&index=0&id=77f68cb2&prod&lang=scss&scoped=true"
import style1 from "./PlatformCy.vue?vue&type=style&index=1&id=77f68cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f68cb2",
  null
  
)

export default component.exports